import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./components/layout/Adminlayout";
import Dashboard from "./pages/Dashboard";
import ServicesPage from "./pages/ServicesPage";
import Categori from "./pages/Categori";
import MessagePage from "./pages/message";
import Users from "./pages/Users";
import Login from "./pages/Login";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import { restoreAuth } from "./utils/auth";

restoreAuth();

export default function App() {
  const [dashboardSearch, setDashboardSearch] = useState("");
  const [servicesSearch, setServicesSearch] = useState("");
  const [categoriesSearch, setCategoriesSearch] = useState("");
  const [messagesSearch, setMessagesSearch] = useState("");
  const [usersSearch, setUsersSearch] = useState(""); // ✅ added

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <AdminLayout title="Dashboard" searchValue={dashboardSearch}
              onSearchChange={(e) => setDashboardSearch(e.target.value)} placeholder="Search dashboard...">
              <Dashboard search={dashboardSearch} />
            </AdminLayout>
          </ProtectedRoute>
        } />
        <Route path="/categories" element={
          <ProtectedRoute>
            <AdminLayout title="Catégories" searchValue={categoriesSearch}
              onSearchChange={(e) => setCategoriesSearch(e.target.value)} placeholder="Search categories...">
              <Categori search={categoriesSearch} />
            </AdminLayout>
          </ProtectedRoute>
        } />
        <Route path="/services" element={
          <ProtectedRoute>
            <AdminLayout title="Services" searchValue={servicesSearch}
              onSearchChange={(e) => setServicesSearch(e.target.value)} placeholder="Search services...">
              <ServicesPage search={servicesSearch} />
            </AdminLayout>
          </ProtectedRoute>
        } />
        <Route path="/messages" element={
          <ProtectedRoute>
            <AdminLayout title="Messages" searchValue={messagesSearch}
              onSearchChange={(e) => setMessagesSearch(e.target.value)} placeholder="Search messages...">
              <MessagePage search={messagesSearch} />
            </AdminLayout>
          </ProtectedRoute>
        } />
        <Route path="/Users" element={
          <ProtectedRoute>
            <AdminLayout title="Utilisateurs" searchValue={usersSearch}
              onSearchChange={(e) => setUsersSearch(e.target.value)} placeholder="Search users..."> {/* ✅ fixed */}
              <Users search={usersSearch} /> {/* ✅ fixed */}
            </AdminLayout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}